export const urlObject = {
  url: '',
  selectedType: 'ftp',
  login: '',
  password: '',
  hostPath: '',
  secure: false, // HTTP, FTP, HTTP+HLS
  showDetails: false,
}

export function buildURL (urlObj) {
  let scheme = urlObj.selectedType
  if (scheme === 'http' && urlObj.secure) {
    scheme = 'https'
  }
  if (scheme === 'ftp' && urlObj.secure) {
    scheme = 'sftp'
  }
  let lp = ''
  if (urlObj.login) {
    lp = urlObj.password ? `${urlObj.login}:${urlObj.password}@` : `${urlObj.login}@`
  }
  const { hostPath } = urlObj
  return `${scheme}://${lp}${hostPath}`
}

export const parseURL = (url) => {
  const match = url.match(/^(http|https|sftp|ftp|aspera|azure|origin|[\w\+]+)?(?:[\:\/]*)([0-9A-Za-z-`!#$[\]*\\.%_\+~=]+@|[0-9A-Za-z-`!#$[\]*\\.%_\+~=]+:[0-9A-Za-z-`!#$[\]*\\.%_\+~=]+@)?([A-Za-z0-9\.-]*?)(?:\:([0-9]+))?(\/[^?#]*)?(?:\?([^#]*))?(?:#(.*))?$/i)
  const ret = {
    protocol: '',
    login: '',
    password: '',
    host: '',
    port: '',
    path: '',
    query: '',
    fragment: '',
  }
  if (!match) {
    return ret
  }
  if (match[1]) {
    ret.protocol = match[1]
  }
  if (match[2]) {
    const lp = match[2].split(':')
    if (lp.length === 2) {
      ret.login = lp[0]
      ret.password = lp[1].substr(0, lp[1].length - 1)
    } else {
      ret.login = lp[0].substr(0, lp[0].length - 1)
    }
  }
  if (match[3]) {
    ret.host = match[3]
  }
  if (match[4]) {
    ret.port = match[4]
  }
  if (match[5]) {
    ret.path = match[5]
  }
  if (match[6]) {
    ret.query = match[6]
  }
  if (match[7]) {
    ret.fragment = match[7]
  }
  return ret
}

export const joinURL = (parsed) => {
  let path = parsed.path.replace(/\/\/+/g, '/')
  path = path === '/' ? '' : path
  let hostPath = parsed.port ? `${parsed.host}:${parsed.port}${path}` : `${parsed.host}${path}`
  if (parsed.query || parsed.fragment) {
    hostPath += `?${parsed.query}${parsed.fragment}`
  }
  hostPath = hostPath.replace(/^\/+/g, '') || ''
  const scheme = parsed.protocol
  const { login, password } = parsed
  let lp = ''
  if (login) {
    lp = password ? `${login}:${password}@` : `${login}@`
  }
  return `${scheme}://${lp}${hostPath}`
}

export const processURLInfo = (urlObj, supportedSchemes, defaultScheme = 'http') => {
  const { url } = urlObj
  const parsed = parseURL(url)
  const result = {
    showDetails: urlObj.showDetails,
  }

  let path = parsed.path.replace(/\/\/+/g, '/')
  path = path === '/' ? '' : path

  let hostPath = parsed.port ? `${parsed.host}:${parsed.port}${path}` : `${parsed.host}${path}`
  if (parsed.query || parsed.fragment) {
    hostPath += `?${parsed.query}${parsed.fragment}`
  }

  hostPath = hostPath.replace(/^\/+/g, '') || ''
  result.hostPath = hostPath

  let scheme = parsed.protocol
  switch (scheme) {
    case 'http':
    case 'ftp':
    case 'aspera':
    case 'origin':
    case 'azure':
    case 'rtmp':
    case 'upd':
    case 'srt':
    case 'http+hls':
      result.selectedType = scheme
      result.secure = false
      break
    case 'https':
      result.selectedType = 'http'
      result.secure = true
      break
    case 'https+hls':
      result.selectedType = 'http+hls'
      result.secure = true
      break
    case 'sftp':
      result.selectedType = 'ftp'
      result.secure = true
      break
    default:
      scheme = defaultScheme
      result.secure = false
      result.selectedType = defaultScheme
  }

  // eslint-disable-next-line no-prototype-builtins
  if (!supportedSchemes.hasOwnProperty(scheme)) {
    scheme = defaultScheme
    result.secure = false
    result.selectedType = defaultScheme
  }

  const { login, password } = parsed
  result.login = login || ''
  result.password = password || ''

  let lp = ''
  if (login) {
    lp = password ? `${login}:${password}@` : `${login}@`
  }
  result.url = `${scheme}://${lp}${hostPath}`
  return result
}
